import axios from 'axios';
import qs from 'qs';
import _ from 'lodash';
import { APIService } from '@/services/APIService';

export class api_general extends APIService {
  constructor(api_base_url, is_dummy = false) {
    super(api_base_url);
    // this.is_dummy = true;
  }
  getSchoolList() {
    var self = this;
    const url = `${this.api_base_url}/api/iot/getSchoolList.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
        }
      }).then(response => response.data);
    }
  }
  getUserInfo(username){
    const url = `${this.api_base_url}/api/iot/getUserInfo.php`;
    return axios.get(url, {
      params: {
        username: username,
      }
    }).then(response => response.data);
  }
  getUserSchool(username){
    const url = `${this.api_base_url}/api/iot/getUserSchool.php`;
    return axios.get(url, {
      params: {
        username: username,
      }
    }).then(response => response.data);
  }
  getSchool(school) {
    const url = `${this.api_base_url}/api/iot/getSchool.php`;
    var dummy_response = {
      slots: [
        {
          start_at: '12:00 PM',
          end_at: '12:55 PM',
          status: 'IDLE',
          user_id: ""
        },
        {
          start_at: '1:00 PM',
          end_at: '1:55 PM',
          status: 'IDLE',
          user_id: ""
        }
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school: school,
        }
      }).then(response => response.data);
    }
  }
  userSchoolVerify(username, school_id){
    const url = `${this.api_base_url}/api/iot/userSchoolVerify.php`;
    return axios.get(url, {
      params: {
        username: username,
        school_id: school_id
      }
    }).then(response => response.data);
  }
  getOngoingBookSlots(school_id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/getOngoingBookSlots.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id,
        }
      }).then(response => response.data);
    }
  }  
  getOngoingGroupExperimentByUserRight(school_id, username) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/getOngoingGroupExperimentByUserRight.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id,
          username: username,
        }
      }).then(response => response.data);
    }
  }
  getSystemAnnouncement() {
    var self = this;
    const url = `${this.api_base_url}/api/iot/getSystemAnnouncement.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
        }
      }).then(response => response.data);
    }
  }
  getSchoolAnnouncement(school_id) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/getSchoolAnnouncement.php`;
    var dummy_response = {
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_id: school_id,
        }
      }).then(response => response.data);
    }
  }
}